module.exports = __webpack_public_path__ + "img/OGBull.05528.fe11cf8e.webp";